<div class="agent-process">
    <ngb-progressbar class="bar agent" type="success" [value]="progressValue" />
    <div *ngFor="let step of agentSteps; let last = last; let i = index;" class="d-flex align-items-center step"
        [ngClass]="{'complete': isAgentStepComplete(step), 'last': last, 'active': currentStep === step && !isAgentStepComplete(step)}">
        <div class="d-flex align-items-center justify-content-center circle-wrapper">
            <ng-container *ngIf="!isLastStepLoading || !last || isAgentStepComplete(step)">
                <circle-progress [percent]="currentStep !== step ? 0 : stepProgressValue" [maxPercent]="100"
                    [radius]="13" [innerStrokeWidth]="4" [outerStrokeWidth]="4"
                    *ngIf="!isAgentStepComplete(step)"></circle-progress>
                <span class="process-circle rounded-circle d-flex justify-content-center align-items-center"
                    *ngIf="isAgentStepComplete(step)">
                    <fa-icon class="custom-icon" [icon]="faCheck" size="xs"></fa-icon>
                </span>
            </ng-container>
            <circle-progress *ngIf="isLastStepLoading && last && !isAgentStepComplete(step)" class="spinner centered"
                [percent]="pacedSteps ? stepProgressValue : 20"
                [maxPercent]="100" [radius]="13" [innerStrokeWidth]="4" [outerStrokeWidth]="4" [space]="'-4'"
                [outerStrokeColor]="'#954fc6'" [innerStrokeColor]="'#f5edfe'"></circle-progress>
        </div>
        <span class="step-text">{{getAgentStepTranslationKey(step) | translate}}</span>
    </div>
    <div class="setup-reassurance" *ngIf="reassuranceKey">{{ reassuranceKey | translate
        }}<span class="setup-reassurance-dots" aria-hidden="true"></span></div>
    <rosie-alert *ngIf="errorMessage" [innerHtml]="errorMessage" [type]="'success'"></rosie-alert>
</div>